// core
import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'open-tooltip',
  templateUrl: './open-tooltip.component.html',
  styleUrls: ['./open-tooltip.component.scss']
})
export class OpenTooltipComponent {
  @Input() tooltipContent!: string;
  @Input() tooltipType: string = 'icon';
  @Input() tooltipIcon: string = 'help_outline';
  @Input() tooltipLabel: string = '';
  @Input() classes: string = '';

  @ViewChild('dialog') dialog!: ElementRef;

  constructor() { }

  public openTooltip() {
    this.dialog.nativeElement.showModal();
  }

  public closeTooltip() {
    this.dialog.nativeElement.close();
  }

  public backdropClicked(event:Event) {
    event.stopPropagation();
    if (!(event.target instanceof HTMLElement)) return;

    if(event && event.target && event.target.nodeName === 'DIALOG') {
      event.stopPropagation();
      this.closeTooltip();
    }
    
  }
}
